import { forwardRef, type ChangeEvent } from 'react';
import { Input, type InputProps } from '@/shared/components/Input';
import { MASKS, type MaskName } from '@/shared/helpers/masks';

export interface MaskedInputProps extends Omit<InputProps, 'onChange' | 'value'> {
  mask: MaskName;
  value: string;
  /** Recebe o valor **ja mascarado**. Use `unmask()` antes de enviar a API. */
  onChange: (value: string) => void;
}

/**
 * Campo com mascara de digitacao.
 *
 * A mascara guia; quem decide se o valor e valido e o schema Zod, no `blur`.
 * Separar os dois evita o padrao em que a mascara "aceita" um CPF invalido apenas
 * por ter a forma certa.
 */
export const MaskedInput = forwardRef<HTMLInputElement, MaskedInputProps>(function MaskedInput(
  { mask, value, onChange, inputMode = 'numeric', ...rest },
  ref,
) {
  const handleChange = (event: ChangeEvent<HTMLInputElement>): void => {
    onChange(MASKS[mask](event.target.value));
  };

  return <Input ref={ref} value={value} onChange={handleChange} inputMode={inputMode} {...rest} />;
});
